import {getObjectProp} from './object';

/**
 * @param {object} data
 *
 * @return {boolean}
 */
export const agencyHasAccess = data =>
  getObjectProp(data.agency, 'has_viewme_access') === 'yes';

/**
 * @param {object} data
 *
 * @return {object}
 */
export const prepareAgencyDetails = data => ({
  id: getObjectProp(data, 'id'),
  city: getObjectProp(data, 'address_physical_city'),
  companyName: getObjectProp(data, 'company_name_tenancy_application'),
  logo: getObjectProp(data, 'logo'),
  clientCode: getObjectProp(data, 'client_code'),
  hasBookMeAccess: getObjectProp(data, 'has_viewme_access') === 'yes',
  remarketingEnabled:
    getObjectProp(data, 'application_form_settings.remarketing') === true,
});
